import React from 'react'
import Header from '../modules/header'
import Footer from '../modules/footer'

import './layout.scss'
import '../styles/container.scss'

const Layout = ({ children }) => (
  <div>
    <Header />
    <main>{children}</main>
    <Footer />
  </div>
)

export default Layout
